var exports = {
  "yu": "metadata__lB1fsH",
  "Rm": "secondary__A3WMMH",
  "zB": "primary__8l2U1W",
  "Wk": "alignRight__Yldhd0",
};

module.exports = exports;
